import {useApolloClient} from '@jimmyn/apollo-client';
import {Switch} from 'antd';
import {useTestModeState} from 'hooks/useTestModeState';
import {delay} from 'lib/utils';
import React from 'react';
import styled from 'styled-components';

type Props = {};

const TestSwitch = styled(Switch)`
  &.ant-switch-checked {
    background-color: #d77e45;
  }
`;

export const TestModeSwitch: React.FC<Props> = () => {
  const [testMode, setTestMode] = useTestModeState(false);
  const client = useApolloClient();
  const handleChange = async (checked: boolean) => {
    setTestMode(checked);
    await delay(100);
    await client.resetStore();
  };
  return (
    <TestSwitch
      checkedChildren="Test data"
      unCheckedChildren="Live data"
      checked={testMode}
      onChange={handleChange}
    />
  );
};
